import axios from "axios";
import {SlackUsersDocument} from "@/interfaces/slack.interfaces";

export async function UserSlack(): Promise<SlackUsersDocument[]> {
  try {
    const res = await axios.get('/apislack/user.list')
    return res ? res.data : []
  } catch (e: any) {
    console.log('UserSlack failed ', e.message)
    return []
  }
}